import { Screen } from '~/screens/StressAssessments/role-select';

export const StressAssessmentsRoleSelect: React.FC = () => {
  return <Screen />;
};
